import {
  Component,
  OnInit,
  ViewChild,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  OnDestroy,
  ChangeDetectorRef,
  ElementRef,
  HostListener
} from '@angular/core';
import { MapFilterDataOut } from 'src/app/models/mapFilterDataOut.model';
import { MapFilter } from 'src/app/models/mapFilter.model';
import { DashboardService } from 'src/app/services/dashboard.service';
import { SelectItem } from 'src/app/models/mapFilter.model';
import { AdditionalInfo } from 'src/app/models/additionalInfo.model';
import { DashboardBpsService } from 'src/app/services/bps/dashboard.service';
import { Coordinates } from 'src/app/models/coordinates.model';
import { MapEntityType } from 'src/app/enums/map-entity-type.enum';
import { MapToggleService } from 'src/app/services/map-toggle.service';
import { MapConfiguration } from 'src/app/models/utility.model';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
})
export class MapComponent implements OnInit, OnDestroy {
  @ViewChild('mapContainer', { static: true }) mapContainer!: ElementRef;
  agmMap: google.maps.Map;
  // googleMap: GoogleMap
  mapData: MapFilterDataOut[] = [];
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event): void {
    if (!this.mapContainer.nativeElement.contains(event.target)) {
      this.infoWindow?.close();
      this.infoWindowVisible = false;
    }
  }

  @Output() buttonClicked = new EventEmitter<string>();


  @Input() selectedAssets: SelectItem[] = [];
  @Input() areaIds: number[] = [];
  @Input() dtsIds: number[] = [];
  @Input() utilityId: number;
  @Input() reloadMapTrigger: boolean = true;
  @Input() defaultCoordinates: Coordinates;
  @Input() mapConfiguration: MapConfiguration;

  regions: SelectItem[] = [];
  searchValue: string = '';

  northEastLat: number = 0;
  northEastLng: number = 0;
  southWestLat: number = 0;
  southWestLng: number = 0;
  zoom: number = 6;

  // // Accra, Ghana capital
  lat: number = 5.6026283219970585;
  lng: number = -0.18522295756972676;

  markerPosition = { lat: this.lat, lng: this.lng };

  lastSentLongitude: number = 0;
  lastSentLatitude: number = 0;

  drag = false;
  mapStep = 0.00005;

  isMenuOpen = false;
  isSearch: boolean = true;
  isMenuOpenRegion = false;
  buName: string = '';

  entity: string = '';
  additionalInfo: string = '';
  buildingCustomers: any;
  tooltipCustomer: any;
  tooltipBuilding: any;
  tooltipPole: any;
  tooltipDt: any;
  tooltipPositionX: number = 0;
  tooltipPositionY: number = 0;
  tooltipHidden: boolean = true;
  isInitialLoad: boolean = true;
  isStreetViewVisible: boolean = false;
  infoWindowVisible: boolean = false;
  isMapExpanded: boolean = false;
  isStreetViewLayerVisible: boolean = false;
  infoWindow: google.maps.InfoWindow | null = null;
  @Output() mapExpandedChanged: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('streetviewSmall') streetviewSmall: any;
  pegmanOption: Element | null;
  streetViewLayer: google.maps.StreetViewCoverageLayer;
  panorama!: google.maps.StreetViewPanorama;

  // Tooltip options
  hoveredMapItemId: string | null = null;
  moveTooltipBottom: boolean = false;
  moveTooltipTop: boolean = false;
  moveTooltipRight: boolean = false;
  moveTooltipLeft: boolean = true;
  moveTooltipTopRight: boolean = false;
  moveTooltipBottomRight: boolean = false;
  constructor(
    private dashboardService: DashboardService,
    private dashboardBpsService: DashboardBpsService,
    private cdr: ChangeDetectorRef,
    private mapToggleService: MapToggleService
  ) {}

  mapOptions: google.maps.MapOptions = {
    fullscreenControl: false
  };

  ngOnInit(): void {
    (window as any).angularComponent = this;

    //this.getMapData();
  }

  ngOnDestroy(): void {
    if (this.pegmanOption) {
      this.pegmanOption?.removeEventListener(
        'click',
        this.streetViewToggleListener
      );
    }
  }

  switchButtonClicked(buttonClicked: string): void{
    if(buttonClicked == 'tree-btn'){
      if(this.isMapExpanded){
        this.toggleMap();
      }
    }
    this.buttonClicked.emit(buttonClicked);
  }

  private getMapFilter(
    mapEntityType: MapEntityType,
    fromSearch: boolean = false
  ) {
    let mapFilter = new MapFilter();
    mapFilter.Assets = this.selectedAssets;
    for (var i = 0; i < this.regions.length; i++) {
      if (this.regions[i].checked) {
        mapFilter.BuID = this.regions[i].Value;
        break;
      }
    }
    if (fromSearch) {
      this.zoom = 6;
      var latitude = localStorage.getItem('latitude');
      var longitude = localStorage.getItem('longitude');
      this.lat = latitude != null ? parseFloat(latitude) : 5.906986824806585;
      this.lng = longitude != null ? parseFloat(longitude) : 0.381388470567412;
    }

    mapFilter.SearchValue = this.searchValue;
    mapFilter.NorthEastLat = this.northEastLat;
    mapFilter.NorthEastLng = this.northEastLng;

    mapFilter.SouthWestLat = this.southWestLat;
    mapFilter.SouthWestLng = this.southWestLng;
    mapFilter.Zoom = this.zoom;
    mapFilter.mapEntityType = mapEntityType;
    mapFilter.DtIds = this.dtsIds;
    this.lastSentLongitude = this.northEastLng;
    this.lastSentLatitude = this.northEastLat;
    return mapFilter;
  }
  public getMapData(fromSearch: boolean = false) {
    if (
      this.mapConfiguration &&
      (this.isInitialLoad)
    ) {
      this.lat = this.mapConfiguration.latitude!;
      this.lng = this.mapConfiguration.longitude!;
      this.zoom = this.mapConfiguration.zoom!;
      this.isInitialLoad = false;
    } else {
      this.mapData = [];
      this.removeAllMarkers();
      this.getCustomerMapData(fromSearch);
      this.getBuildingMapData(fromSearch);
      this.getTransformerMapData(fromSearch);
      this.getPoleMapData(fromSearch);
    }
  }

  getCustomerMapData(fromSearch: boolean = false) {
    let obj = {
      mapFilter: this.getMapFilter(MapEntityType.CUSTOMER, fromSearch),
      areaIds: this.areaIds,
      utilityId: this.utilityId,
    };
    this.mapRequest(obj);
  }
  getBuildingMapData(fromSearch: boolean = false) {
    let obj = {
      mapFilter: this.getMapFilter(MapEntityType.BUILDING, fromSearch),
      areaIds: this.areaIds,
      utilityId: this.utilityId,
    };
    this.mapRequest(obj);
  }
  getPoleMapData(fromSearch: boolean = false) {
    let obj = {
      mapFilter: this.getMapFilter(MapEntityType.POLE, fromSearch),
      areaIds: this.areaIds,
      utilityId: this.utilityId,
    };
    this.mapRequest(obj);
  }
  getTransformerMapData(fromSearch: boolean = false) {
    let obj = {
      mapFilter: this.getMapFilter(MapEntityType.TRANSFORMER, fromSearch),
      areaIds: this.areaIds,
      utilityId: this.utilityId,
    };
    this.mapRequest(obj);
  }

  onMapClick(event: google.maps.MapMouseEvent) {
    if (this.infoWindowVisible) {
      this.infoWindow?.close();
      this.infoWindowVisible = false;
    }
  }

  private mapRequest(obj: any) {
    if (this.utilityId) {
      this.dashboardBpsService.getMapData(obj).subscribe({
        next: (data) => {
          var mapData = data?.body?.data?.length
            ? data?.body?.data.map((el: any) => new MapFilterDataOut(el))
            : [];
          this.cdr.detectChanges(); // Trigger change detection
          this.mapData = [...this.mapData, ...mapData];
          this.addMarkers();
        },
        error: (error) => console.log(error.statusText),
      });
    } else {
      this.dashboardService.getMapData(obj).subscribe({
        next: (data) => {
          var mapData = data?.body?.data?.length
            ? data?.body?.data.map((el: any) => new MapFilterDataOut(el))
            : [];
          this.cdr.detectChanges();
          this.mapData = [...this.mapData, ...mapData];
          this.addMarkers();
        },
        error: (error) => console.log(error.statusText),
      });
    }
  }
  onZoomChange() {
    this.zoom = this.agmMap.getZoom()!;
  }

  mapBoundsChange() {
    // var event = this.agmMap.getBounds();
    // this.northEastLat = event.getNorthEast().lat();
    // this.northEastLng = event.getNorthEast().lng();
    // this.southWestLat = event.getSouthWest().lat();
    // this.southWestLng = event.getSouthWest().lng();

    const bounds = this.agmMap.getBounds();

    if (bounds) {
      // Extract the north-east and south-west coordinates
      const northEast = bounds.getNorthEast();
      const southWest = bounds.getSouthWest();

      // Update your variables
      this.northEastLat = northEast.lat();
      this.northEastLng = northEast.lng();
      this.southWestLat = southWest.lat();
      this.southWestLng = southWest.lng();
    }

    this.hideTooltip();
  }

  mapReady(event: google.maps.Map) {
    this.agmMap = event;
    this.streetViewLayer = new google.maps.StreetViewCoverageLayer();

    setTimeout(() => {
      this.pegmanOption = window?.document.querySelector('button.gm-svpc');

      if (this.pegmanOption) {
        this.pegmanOption?.addEventListener(
          'click',
          this.streetViewToggleListener
        );
      }
    }, 1500);
  }

  loaded() {
    if (!this.drag) {
      this.getMapData();
    } else {
      this.drag = false;
    }
  }

  zoomPoint(event: any, data: MapFilterDataOut) {
    this.isStreetViewVisible = true;
    this.showSmallStreetView(data.latitude, data.longitude);
    // this.showTooltip(event, data.additionalInfo, data.type);
  }

  showTooltip(event: any, additionalInfo: AdditionalInfo, entity: string) {
    this.tooltipHidden = false;

    this.placeTooltip(entity, additionalInfo, event);
  }

  placeTooltip(entity: string, additionalInfo: AdditionalInfo, event: any) {
    this.entity = entity;
    this.additionalInfo = additionalInfo.id;
    this.buildingCustomers = additionalInfo.customers;
    this.tooltipCustomer = additionalInfo.tooltipCustomer;
    this.tooltipBuilding = additionalInfo.tooltipBuilding;
    this.tooltipPole = additionalInfo.tooltipPole;
    this.tooltipDt = additionalInfo.tooltipDt;
    this.hoveredMapItemId = additionalInfo.id;
    this.calculateTooltipPosition(event);
  }

  hideTooltip() {
    this.hoveredMapItemId = null;
  }
  markerProperties: google.maps.MarkerOptions = {
    //zIndex: 100
  };
  zoomCluster(data: any) {
    if (this.zoom + 4 > 22) {
      this.zoom = 22;
    } else {
      this.zoom += 4;
    }

    this.lat = data.latitude;
    this.lng = data.longitude;
  }

  ngOnChanges(): void {
    if (this.isInitialLoad && this.mapConfiguration) {
      if (this.mapConfiguration.latitude != null &&
          this.mapConfiguration.longitude != null) {
        this.lat = this.mapConfiguration.latitude!;
        this.lng = this.mapConfiguration.longitude!;
      }

      if (this.mapConfiguration.zoom != null) {
        this.zoom = this.mapConfiguration.zoom!;
      }

      if (this.mapConfiguration.mapType) {
        this.mapOptions.mapTypeId =
          this.mapConfiguration.mapType as google.maps.MapTypeId;
      }

      if (this.mapConfiguration.mapTheme) {
        try {
          this.mapOptions.styles = JSON.parse(this.mapConfiguration.mapTheme);
        } catch {
          console.warn("Invalid mapTheme JSON in mapConfiguration");
        }
      }

      if (!this.utilityId) {
        this.getMapData();
      }
      this.isInitialLoad = false;

      return;
    }

    if (this.isInitialLoad && this.defaultCoordinates) {

      this.lat = this.defaultCoordinates.latitude!;
      this.lng = this.defaultCoordinates.longitude!;

      if (!this.utilityId) {
        this.getMapData();
      }
      this.isInitialLoad = false;

      return;
    }
  }

  /**
   * It will show a street view container in the bottom right of the map
   * @param lat Location latitude
   * @param lng Location longitude
   */
  showSmallStreetView(lat: number, lng: number) {
    let streetViewPosition: google.maps.LatLngLiteral = { lat: lat, lng: lng };
    this.panorama = new window['google'].maps.StreetViewPanorama(
      this.streetviewSmall.nativeElement,
      {
        position: streetViewPosition,
        scrollwheel: true,
        zoom: 1,
        fullscreenControl: true,
        showRoadLabels: true,
        visible: true,
        addressControl: false,
        panControl: true,
      }
    );

    this.agmMap.setStreetView(this.panorama);
    this.hidePegmanContainer();
  }

  /**
   * It will listen for click events on the "pegman" option on the map and
   * display/hide street view layer (blue line showing where street view is available)
   * @param event An event which takes place in the DOM
   */
  streetViewToggleListener: EventListener = (event: Event) => {
    this.isStreetViewLayerVisible = !this.isStreetViewLayerVisible;
    // console.log('PEGMAN CLICKED');

    if (this.isStreetViewLayerVisible) {
      this.streetViewLayer.setMap(this.agmMap);
    } else {
      this.streetViewLayer.setMap(null);
    }
  };

  onAssetMouseEnter(event: any, data: MapFilterDataOut) {
    this.showTooltip(event, data.additionalInfo, data.type);
  }

  onAssetMouseLeave() {
    this.hideTooltip();
  }

  /**
   * It will hide a pegman outer container that disable a hover effect on the current asset (pin)
   */
  hidePegmanContainer() {
    setTimeout(() => {
      let pegmanImg: Element | null = window?.document.querySelector(
        "[src='https://maps.gstatic.com/mapfiles/transparent.png']"
      );

      if (!pegmanImg) {
        return;
      }

      let parentDiv = pegmanImg.parentElement;
      // console.log('parent', parent);

      parentDiv?.setAttribute('style', 'width: 0px !important;');
    }, 500);
  }

  calculateTooltipPosition(event: any) {
    const mapContainer = document.getElementById('map-component')!;
    // const pageContainer = document.getElementById('page-wraper')!;
    const mapContainerRect = mapContainer.getBoundingClientRect();
    // const pageContainerRect = pageContainer.getBoundingClientRect();

    let popupWidth: number = 170;
    let isOnLeftEdge: boolean =
      event.clientX - mapContainerRect.left < popupWidth;
    // let isOnRightEdge: boolean = (pageContainerRect.width / devicePixelRatio - event.screenX) < popupWidth;
    let isOnTopEdge: boolean = false;
    let isOnBottomEdge: boolean =
      Math.abs(event.screenY - mapContainerRect.bottom) < popupWidth;

    if (mapContainerRect.top > 0) {
      isOnTopEdge = event.clientY - mapContainerRect.top < popupWidth;
    }

    // Tooltip is moved left by default
    this.resetTooltipPositions();

    if (isOnLeftEdge && isOnBottomEdge) {
      this.moveTooltipLeft = false;
      this.moveTooltipTopRight = true;
      return;
    }

    if (isOnLeftEdge && isOnTopEdge) {
      this.moveTooltipLeft = false;
      this.moveTooltipBottomRight = true;
      return;
    }

    if (isOnTopEdge) {
      this.moveTooltipBottom = true;
    }

    if (isOnLeftEdge) {
      this.moveTooltipRight = true;
      this.moveTooltipLeft = false;
    }

    if (isOnBottomEdge) {
      this.moveTooltipTop = true;
    }
  }

  resetTooltipPositions() {
    this.moveTooltipBottom = false;
    this.moveTooltipTop = false;
    this.moveTooltipRight = false;
    this.moveTooltipTopRight = false;
    this.moveTooltipBottomRight = false;
    this.moveTooltipLeft = true;
  }

  /**
   * It will listen for events fired when the map becomes idle after panning or zooming.
   */
  mapIdleListener() {
    if (
      !this.utilityId &&
      (Math.abs(this.northEastLng - this.lastSentLongitude) > this.mapStep ||
      Math.abs(this.northEastLat - this.lastSentLatitude) > this.mapStep)
    ) {
      this.getMapData();
      this.drag = true;
    }
  }

  //////////////////////////////////////////////CHANGES FOR NEW MAP APPROACH///////////////////////////////////
  markers: google.maps.Marker[] = [];

  addMarkers(): void {
    this.mapData.forEach((markerData) => {
      let label =
        markerData.count != null && markerData.count > 0
          ? markerData.count.toString()
          : '1';
      const marker = new google.maps.Marker({
        position: { lat: markerData.latitude, lng: markerData.longitude },
        map: this.agmMap,
        icon:
          label != '1'
            ? this.getCustomMarkerIcon(markerData)
            : this.getCustomMarkerPoint(markerData),
        label: {
          text: label,
          color: 'white', // Font color
          fontSize: '10px', // Font size
          fontWeight: 'bold', // Font weight
        },
      });

      this.markers.push(marker);
      // Set up the click event listener for each marker
      let timeoutId: any;
      if (label != '1') {
        marker.addListener('click', () => {
          this.zoomCluster(markerData);
        });
      } else {
        var infowindow = new google.maps.InfoWindow({
          disableAutoPan: true,
          headerDisabled: true,
          content: this.getInfoContent(markerData),
        });
        if (markerData.type != 'CUSTOMER') {
          marker.addListener('mouseover', () => {
            if (timeoutId) {
              clearTimeout(timeoutId);
            }
            if (!this.infoWindowVisible) {
              this.infoWindow = infowindow;
              infowindow.open(this.agmMap, marker);
              infowindow.setOptions({
                pixelOffset: this.getInfowindowOffset(marker, markerData.type),
              });
            }
          });
          marker.addListener('mouseout', () => {
            if (!this.infoWindowVisible) {
              timeoutId = setTimeout(() => {
                infowindow.close();
              }, 200); // Adjust delay (200ms) as needed
            }
          });
          marker.addListener('click', () => {
            if (!this.infoWindowVisible) this.infoWindowVisible = true;
            else {
              this.infoWindow?.close();
              this.infoWindow = infowindow;
              infowindow.open(this.agmMap, marker);
              infowindow.setOptions({
                pixelOffset: this.getInfowindowOffset(marker, markerData.type),
              });
            }
            this.isStreetViewVisible = true;
            this.showSmallStreetView(markerData.latitude, markerData.longitude);
          });
          infowindow.addListener('mouseout', () => {
            timeoutId = setTimeout(() => {
              infowindow.close();
            }, 200);
          });
        }
      }
    });
  }

  getPixelFromLatLng(latLng: any) {
    var projection = this.agmMap.getProjection();
    //refer to the google.maps.Projection object in the Maps API reference
    var point = projection?.fromLatLngToPoint(latLng);
    return point;
  }
  getInfowindowOffset(marker: any, type: string) {
    var center = this.getPixelFromLatLng(this.agmMap.getCenter()),
      point = this.getPixelFromLatLng(marker.getPosition()),
      quadrant = '',
      offset;
    quadrant += point!.y > center!.y ? 'b' : 't';
    quadrant += point!.x < center!.x ? 'l' : 'r';
    if (quadrant == 'tr') {
      offset =
        type == 'POLE'
          ? new google.maps.Size(-120, 160)
          : new google.maps.Size(-120, 240);
    } else if (quadrant == 'tl') {
      offset =
        type == 'POLE'
          ? new google.maps.Size(120, 160)
          : new google.maps.Size(120, 240);
    } else if (quadrant == 'br') {
      offset = new google.maps.Size(-70, 20);
    } else if (quadrant == 'bl') {
      offset = new google.maps.Size(70, 20);
    }

    return offset;
  }
  getInfoContent(markerData: MapFilterDataOut): string {
    var content = '';
    if (markerData.type == 'BUILDING') {
      content = this.getBuildingTooltip(markerData);
    } else if (markerData.type == 'POLE') {
      content = this.getPoleTooltip(markerData);
    } else if (markerData.type == 'CUSTOMER') {
      content = this.getCustomerTooltip(markerData);
    } else if (markerData.type == 'TRANSFORMER') {
      content = this.getTransformerTooltip(markerData);
    }

    const detailsButton = this.utilityId ? '' : `<button class="btn btn-map-asset-details btn-primary"
                    onclick="angularComponent.openDetailsInNewTab('${
                      markerData.type
                    }', '${markerData.additionalInfo.assetId}')">
                    Details
                  </button>`;
    return (
      `
      <div class="pin anti-zoom">
      <div class="pin-item"

        class="${markerData.type.toLowerCase()}"></div>

      <div id="tooltip-div" style="font-size: 1.1rem !important;min-width: 18rem" class="map-tooltip
        ${
          markerData.additionalInfo?.id &&
          this.hoveredMapItemId === markerData.additionalInfo?.id
            ? 'visible'
            : ''
        }">
        <div id="tooltip-id">
          <div class="tooltip-asset" style="font-size: 1.1rem !important" >
            <div class="dot-tooltip ${markerData.type.toLowerCase()}"></div>
            <div class="entity-name" style="font-size: 1.1rem !important" >
              <div style="font-size: 1.1rem !important; display: flex"><span style="padding-top: 0.7rem" class="left-span">${
                markerData.type
              }:</span><span class="left-span left-span-second">${detailsButton}</span><span class="right-span-close" onclick="angularComponent.closeInfoWindow()">x</span></div>
                                              <div style="font-size: 1.1rem !important; font-weight:700" >${
                                                markerData.additionalInfo.id
                                              }</div>

            </div>
          </div>
          <hr>


    ` +
      content +
      `   </div>
      </div>
    </div>`
    );
  }

  removeAllMarkers() {
    this.markers.forEach((marker) => {
      marker.setMap(null);
    });
    this.markers = []; // Clear the marker array
  }

  // Method to generate a custom marker icon with dynamic color and label
  getCustomMarkerIcon(data: MapFilterDataOut) {
    let label =
      data.count != null && data.count > 0 ? data.count.toString() : '1';
    let color = 'black';
    if (data.type == 'BUILDING') color = '#fb9f30';
    else if (data.type == 'POLE') color = '#00875A ';
    else if (data.type == 'CUSTOMER') color = '#ff6347';
    else if (data.type == 'TRANSFORMER') color = '#0052cc ';

    return {
      path: google.maps.SymbolPath.CIRCLE,
      fillColor: color, // dynamic color
      fillOpacity: 1,
      scale: 10, // size of the circle
      strokeColor: color,
      strokeWeight: 15,
      labelOrigin: new google.maps.Point(0, 0),
    };
  }

  getCustomMarkerPoint(data: MapFilterDataOut) {
    let label =
      data.count != null && data.count > 0 ? data.count.toString() : '1';
    let color = 'black';
    if (data.type == 'BUILDING') color = '#fb9f30';
    else if (data.type == 'POLE') color = '#00875A ';
    else if (data.type == 'CUSTOMER') color = '#ff6347';
    else if (data.type == 'TRANSFORMER') color = '#0052cc ';

    return {
      path: 'M12 0c-4.198 0-8 3.403-8 7.602 0 6.243 6.377 6.903 8 16.398 1.623-9.495 8-10.155 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.342-3 3-3 3 1.343 3 3-1.343 3-3 3z',
      fillColor: color, // dynamic color
      fillOpacity: 1,
      scale: 2, // size of the circle
      strokeColor: color,
      strokeWeight: 1,
      labelOrigin: new google.maps.Point(0, 0),
    };
  }

  // Click event handler
  onMarkerClick(marker: any): void {
    alert(`Marker with label: ${marker.label} clicked!`);
  }

  getCustomerTooltip(markerData: MapFilterDataOut) {
    return `
    <div class="tooltip-info tooltip-info-customer" style = "font-size: 1.1rem !important" >
      Acc. No: <b>${
        markerData.additionalInfo?.tooltipCustomer.accountNumber || 'N/A'
      }</b><br>
      MSN: <b>${
        markerData.additionalInfo?.tooltipCustomer.meterNumber || 'N/A'
      }</b><br>
      SLRN: <b>${
        markerData.additionalInfo?.tooltipCustomer.slrn || 'N/A'
      }</b><br>
      SLT: <b>${markerData.additionalInfo?.tooltipCustomer.slt || 'N/A'}</b>
    </div>
  `;
  }
  getBuildingTooltip(markerData: MapFilterDataOut) {
    return `
    <div class="tooltip-info tooltip-info-building" style = "font-size: 1.1rem !important" >
      No. of accounts: <b>${
        markerData.additionalInfo?.tooltipBuilding.numberOfAccounts || 0
      }</b>
    </div>
    ${
      markerData.additionalInfo.customers?.length
        ? `
      <div class="tooltip-info" style = "font-size: 1.1rem !important" >
        <table class="table table-striped table-hover" style = "font-size: 1.1rem !important" >
          <tr style = "font-size: 1.1rem !important" >
            <th style = "font-size: 1.1rem !important" >#</th>
            <th style = "font-size: 1.1rem !important" >Acc No.</th>
            <th style = "font-size: 1.1rem !important" >Meter No.</th>
          </tr>
          ${markerData.additionalInfo.customers
            .map(
              (customer: any, i: number) => `
            <tr style = "font-size: 1.1rem !important" >
              <td style = "font-size: 1.1rem !important" >${i + 1}</td>
              <td style = "font-size: 1.1rem !important" >${customer.accountNumber}</td>
              <td style = "font-size: 1.1rem !important" >${customer.meterNumber}</td>
            </tr>
          `
            )
            .join('')}
        </table>
      </div>
    `
        : ''
    }
  `;
  }
  getPoleTooltip(markerData: MapFilterDataOut) {
    return `
    <div class="tooltip-info tooltip-info-building" style = "font-size: 1.1rem !important" >
      ID: <b>${markerData.additionalInfo?.id || 'N/A'}</b><br>
      Type: <b>${
        markerData.additionalInfo?.tooltipPole.poleType || 'N/A'
      }</b><br>
      No. of buildings: <b>${
        markerData.additionalInfo?.tooltipPole.numberOfBuildings || 0
      }</b><br>
    </div>
  `;
  }
  getTransformerTooltip(markerData: MapFilterDataOut) {
    return `
    <div class="tooltip-info tooltip-info-transformer" style = "font-size: 1.1rem !important" >
      Name: <b>${markerData.additionalInfo?.tooltipDt.dtName || 'N/A'}</b><br>
      Type: <b>${markerData.additionalInfo?.tooltipDt.dtType || 'N/A'}</b><br>
      Status: <b>${
        markerData.additionalInfo?.tooltipDt.dtStatus || 'N/A'
      }</b><br>
      Customer population: <b>${
        markerData.additionalInfo?.tooltipDt.customerPopulation || 0
      }</b><br>
      No. of Buildings: <b>${
        markerData.additionalInfo?.tooltipDt.numberOfBuildings || 0
      }</b><br>
      No. of Poles: <b>${
        markerData.additionalInfo?.tooltipDt.numberOfPoles || 0
      }</b><br>
    </div>
  `;
  }

  openDetailsInNewTab(assetType: string, id: any) {
    const url = `${assetType.toLowerCase()}s/edit/${id}`;
    // const url = currentUrl + '/assetType/' + 'edit/' + id;
    window.open(url, '_blank');
  }

  closeInfoWindow(){
    this.infoWindow?.close();
    this.infoWindowVisible = false;
  }

  toggleMap() {
    this.mapToggleService.toggleMap();
    this.isMapExpanded = !this.isMapExpanded;

  }
}
